import { Airport } from "@/types/airport";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ArrowUpDown, ChevronDown, Trash2, Edit } from "lucide-react";

interface AirportsTableProps {
  airports: Airport[];
  sortField: 'name' | 'iata_code' | 'location';
  sortDirection: 'asc' | 'desc';
  onSort: (field: 'name' | 'iata_code' | 'location') => void;
  onDelete: (airport: Airport) => void;
  onEdit: (airport: Airport) => void;
}

export function AirportsTable({
  airports,
  sortField,
  sortDirection,
  onSort,
  onDelete,
  onEdit,
}: AirportsTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>
              <Button 
                variant="ghost" 
                onClick={() => onSort('name')}
                className="flex items-center gap-1"
              >
                Name
                <ArrowUpDown className="h-4 w-4" />
              </Button>
            </TableHead>
            <TableHead>
              <Button 
                variant="ghost" 
                onClick={() => onSort('iata_code')}
                className="flex items-center gap-1"
              >
                IATA Code
                <ArrowUpDown className="h-4 w-4" />
              </Button>
            </TableHead>
            <TableHead>
              <Button 
                variant="ghost" 
                onClick={() => onSort('location')}
                className="flex items-center gap-1"
              >
                Location
                <ArrowUpDown className="h-4 w-4" />
              </Button>
            </TableHead>
            <TableHead>Coordinates</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {airports.map((airport) => (
            <TableRow key={airport.id}>
              <TableCell className="font-medium">{airport.name}</TableCell>
              <TableCell>{airport.iata_code || "-"}</TableCell>
              <TableCell>{airport.location}</TableCell>
              <TableCell>
                {airport.latitude.toFixed(6)}, {airport.longitude.toFixed(6)}
              </TableCell>
              <TableCell>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="ghost" size="sm">
                      Actions <ChevronDown className="h-4 w-4" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem onClick={() => onEdit(airport)}>
                      <Edit className="h-4 w-4 mr-2" />
                      Edit
                    </DropdownMenuItem>
                    <DropdownMenuItem 
                      onClick={() => onDelete(airport)}
                      className="text-red-600 focus:text-red-600"
                    >
                      <Trash2 className="h-4 w-4 mr-2" />
                      Delete
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
